import imagesLoaded from 'imagesloaded'

import SingleSection from '../../components/partials/single-section.vue'
import SingleHeader  from '../../components/partials/single-header.vue'

import { EventBus } from '@/main'

export let singleHandler = {

    components: { SingleHeader, SingleSection },

    data() {
        return {
            singleIsHidden: true
        }
    },

    computed: {
        link() {
            let s = this.project.title.toLowerCase()
            s = s.replace(/\s/g, '-')
            s = s.replace(new RegExp(/[àáâãäå]/g),'a')
            s = s.replace(new RegExp(/[èéêë]/g),  'e')
            s = s.replace(new RegExp(/[ìíîï]/g),  'i')
            s = s.replace(new RegExp(/[òóôõö]/g), 'o')
            s = s.replace(new RegExp(/[ùúûü]/g),  'u')
            s = s.replace(new RegExp(/[ß]/g),    'ss')
            return s;
        }
    },

    created() {
        this.project.logo = require('Projects/' + this.link + '/project-logo.' + this.project.logoSuffix) // check svg + png

        if( window.innerWidth < 768 ) {

            this.$nextTick(() => {
                let videos = document.getElementsByTagName('video')
                for( let i = 0; i < videos.length; i++ ) {
                    videos[i].controls = true
                }
            })

        }
    },

    head: {
        title() {
            return { inner: this.project.title }
        },
        meta() {
            return [
                { n: 'description', c: this.project.subtitle, id: 'desc' }, // id to replace intead of create element

                { p: 'og:title', c: this.project.title, id: 'og-title' },
                { p: 'og:url', c: this.project.url, id: 'og-url' },
                { p: 'og:image', c: '//artofmyself.com/assets/projects/' + this.link + '/opengraph.png', id: 'og-image' },
            ]
        }
    },

    beforeRouteLeave(to, from, next) {

        this.singleIsHidden = true

        if( to.name === 'index' ) {
            EventBus.$emit('isSingle', false)
            EventBus.$emit('changeColor', '#3d3d3d')
        }


        setTimeout(() => next(), 400) // wait for transition

    },

    mounted() {

        EventBus.$emit('currentSingle', this.$route.path)

        EventBus.$emit('isLoading', true)

        let single = document.querySelector('.single')

        imagesLoaded( single, { background: '.single-header' }, () => {

            EventBus.$emit('isLoading', false)
            EventBus.$emit('isSingle', true)

            setTimeout(() => this.singleIsHidden = false, 50) // ensure smooth transition
        })
    }

}



// WEBPACK FOOTER //
// ./js/modules/mixins.js